import Content from '@/view/wcba-three-u23-player-comment/player-list/views/Content.vue'

import { RouteRecordRaw, RouterView } from 'vue-router'

export default {
    name: 'wcba-three-23-player-comment',
    path: '/wcba-three-23-player-comment',
    redirect: '/home',
    component: RouterView,
    children: [
        {
            name: 'wcbaThreeU23PlayerCommentHome',
            path: 'home',
            component: () => import('@/view/wcba-three-u23-player-comment/index.vue'),
        },
        {
            name: 'wcba-3v3-u23-player-list',
            path: 'wcba-3v3-u23-player-list',
            component: () => import('@/view/wcba-three-u23-player-comment/player-list/views/Index.vue'),
        },
        {
            name: 'wcba-3v3-u23-content',
            path: 'wcba-3v3-u23-content',
            component: Content,
        },
    ],
} as RouteRecordRaw
